<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import debounce from 'lodash-es/throttle';

export default {
  name: 'XmlChannelStatusControl',
  data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapState({
      systemOptions: state => state.xmlChannelStatus.xmlChannels.systems,
      statusOptions: state => state.xmlChannelStatus.filter.statusOptions,
      statusFilters: state => state.xmlChannelStatus.filter.status,
      searchFilter: state => state.xmlChannelStatus.filter.search,
    }),
    ...mapGetters({
      badges: 'xmlChannelStatus/getBadges',
    }),
  },
  methods: {
    ...mapActions({
      updateXmlChannelFilterSearch: 'xmlChannelStatus/updateXmlChannelFilterSearch',
      updateXmlChannelFilterStatus: 'xmlChannelStatus/updateXmlChannelFilterStatus',
      updateXmlChannelFilterSystem: 'xmlChannelStatus/updateXmlChannelFilterSystem',
    }),
    // eslint-disable-next-line func-names
    updateSearch: debounce(function () {
      this.updateXmlChannelFilterSearch(this.search);
    }, 1000, { leading: true }),
  },
  created() {
    this.search = this.searchFilter;
  },
};
</script>

<template>
  <v-container grid-list-md channel-status-control>
    <v-layout>
      <v-flex xs8 sm4>
        <v-select
          @change="updateXmlChannelFilterSystem"
          :label="$t('xmlChannelStatus.xmlChannelStatusControl.systemLabel')"
          :items="systemOptions"
          class="ma-2"
          clearable
          outline
          chips
          hide-selected
          hide-details
          deletable-chips
        ></v-select>
      </v-flex>
      <v-flex xs8 sm4>
        <v-select
          @change="updateXmlChannelFilterStatus"
          :label="$t('xmlChannelStatus.xmlChannelStatusControl.statusLabel')"
          :items="statusOptions"
          :value="statusFilters"
          item-text="label"
          class="ma-2"
          clearable
          outline
          chips
          multiple
          hide-selected
          hide-details
          deletable-chips
        >
        </v-select>
      </v-flex>
      <v-flex xs8 sm4>
        <v-text-field
          v-model="search"
          @input="updateSearch"
          :label="$t('xmlChannelStatus.xmlChannelStatusControl.searchLabel')"
          :height="72"
          class="ma-2"
          clearable
          hide-details
          outline
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusControl.vue